import jsPDF from "jspdf";
import cryptoJs from "crypto-js";
let secretKey = "5N-LzDy;LcKYHYgp^d]2Q59,}rR=|V&=3/Me,ugIuw]92<7cX@uEmE):+%|/#mA"

export const is_valid = (data) => {
  if (data && data.length) return true
  return false
}

// export const validate_number_field = str => {
//   return str.replace(/[^0-9\.]/g, "").replace(/(?<=\..*)\./g, '')
// }

export const validate_text_field = str => {
  return str.replace(/^\s?/, '')
}

const A4_PAPER_DIMENSIONS = {
  width: 210,
  height: 297,
};

const A4_PAPER_RATIO = A4_PAPER_DIMENSIONS.width / A4_PAPER_DIMENSIONS.height;

const imageDimensionsOnA4 = (dimensions) => {
  const isLandscapeImage = dimensions.width >= dimensions.height;
  // If the image is in landscape, the full width of A4 is used.
  if (isLandscapeImage) {
    return {
      width: A4_PAPER_DIMENSIONS.width,
      height:
        A4_PAPER_DIMENSIONS.width / (dimensions.width / dimensions.height),
    };
  }
  // If the image is in portrait and the full height of A4 would skew
  // the image ratio, we scale the image dimensions.
  const imageRatio = dimensions.width / dimensions.height;
  if (imageRatio > A4_PAPER_RATIO) {
    const imageScaleFactor =
      (A4_PAPER_RATIO * dimensions.height) / dimensions.width;
    const scaledImageHeight = A4_PAPER_DIMENSIONS.height * imageScaleFactor;
    return {
      height: scaledImageHeight,
      width: scaledImageHeight * imageRatio,
    };
  }
  // The full height of A4 can be used without skewing the image ratio.
  return {
    width: A4_PAPER_DIMENSIONS.height / (dimensions.height / dimensions.width),
    height: A4_PAPER_DIMENSIONS.height,
  };
};

export async function convertImageToPdf(imgDataUrl, imgFileName) {
  return new Promise((resolve, reject) => {
    try {
      let pdfFileName = imgFileName.split(".")[0] + ".pdf"
      let image = new Image();
      image.src = imgDataUrl;
      image.onload = function () {
        const doc = new jsPDF();
        doc.deletePage(1);
        const imageDimensions = imageDimensionsOnA4({
          width: image.width,
          height: image.height,
        });
        doc.addPage();
        doc.addImage(
          image.src,
          // Images are vertically and horizontally centered on the page.
          (A4_PAPER_DIMENSIONS.width - imageDimensions.width) / 2,
          (A4_PAPER_DIMENSIONS.height - imageDimensions.height) / 2,
          imageDimensions.width,
          imageDimensions.height,
          "",
          "FAST"
        );
        // To view pdf in new tab
        // const test = doc.output('bloburl')
        // window.open(test, "_blank");
        const pdfBlob = doc.output('blob');
        resolve(
          {
            "file": new File([pdfBlob], pdfFileName, { type: pdfBlob["type"], lastModified: new Date() }),
            "dataUrl": doc.output('datauristring', { filename: pdfFileName })
          }
        );
      };
    }
    catch (error) {
      reject(false)
    }
  })
}

export const GetCache = (key) => {
  return JSON.parse(localStorage.getItem(key)) || {}
}

export const SetCache = (key, data_obj) => {
  localStorage.setItem(key, JSON.stringify({ ...GetCache(key), ...data_obj }))
}

export const ClearCache = (key) => {
  localStorage.removeItem(key)
}

export const encryptData = (strData) => {
  return cryptoJs.AES.encrypt(strData, secretKey).toString()
}

export const decryptData = (encStrData) => {
  let bytes = cryptoJs.AES.decrypt(encStrData, secretKey)
  return bytes.toString(cryptoJs.enc.Utf8)
}

export const cargoTypeDD = [
  { "name": "Break Bulk" },
  { "name": "Bulk Cargo" },
  { "name": "Oversize Load" },
  { "name": "Liquid Cargo" },
  { "name": "Gas" },
  { "name": "Wheeled Carg" }
]

export const containerTypeDD = [
  { "name": "20 Standard" },
  { "name": "40 Standard" },
  { "name": "40 High Cube" },
  { "name": "45 High Cube" },
  { "name": "20 Open Top" },
  { "name": "40 Open Top" },
  { "name": "20 Flatrack" },
  { "name": "40 Flatrack" },
  { "name": "20 Refrigerate" }
]

export const vesselTypeDD = [
  { "name": "General Cargo" },
  { "name": "Bulk Carriers" },
  { "name": "Containership" },
  { "name": "Tanker Market" },
  { "name": "Specialized" }
]

export function calcHaversineDistance(lat1, lon1, lat2, lon2) {
  var R = 6371; // km
  var dLat = toRad(lat2 - lat1);
  var dLon = toRad(lon2 - lon1);
  var lat1 = toRad(lat1);
  var lat2 = toRad(lat2);

  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
}

function toRad(Value) {
  return Value * Math.PI / 180;
}

export const modifi_currencies = [
  { id: 2, name: "Dollars", code: "USD", symbol: "$" },
  { id: 11, name: "Euro", code: "EUR", symbol: "€" },
  { id: 19, name: "Pounds", code: "GBP", symbol: "£" },
  { id: 22, name: "Dollars", code: "CAD", symbol: "$" },
  { "id": 25, "name": "Yuan Renminbi", "code": "CNY", "symbol": "¥" }
]

export const most_used_currencies = [
  { id: 47, name: "Rupees", code: "INR", symbol: "₹" },
  { id: 2, name: "Dollars", code: "USD", symbol: "$" },
  { id: 11, name: "Euro", code: "EUR", symbol: "€" },
  { id: 19, name: "Pounds", code: "GBP", symbol: "£" },
  { id: 44, name: "Dollars", code: "HKD", symbol: "$" },
  { id: 22, name: "Dollars", code: "CAD", symbol: "$" },
  { id: 6, name: "Dollars", code: "AUD", symbol: "$" },
  { id: 63, name: "Switzerland Francs", code: "CHF", symbol: "CHF" },
  { id: 95, name: "Rand", code: "ZAR", symbol: "R" },
  { id: 74, name: "Dollars", code: "NZD", symbol: "$" }
]
